import React, {useState} from 'react';
import {Icon, Typography} from '@bonprix/design-system';

export default function Expand100({children, label, classes = '', defaultOpened = false, onToggle, labelIcon = null, variant = 'body1'}) {
    const [isOpen, setIsOpen] = useState(defaultOpened);

    function onClick() {
        setIsOpen(!isOpen);
        onToggle?.(isOpen);
    }

    return (
        <div className={classes + ' expand-100'}>
            <div className='expand-100__label flex items-center gap-1' onClick={onClick}>
                {labelIcon}
                <Typography variant={variant} component='span'>{label}</Typography>
                <Icon variant={isOpen ? 'arrow-up' : 'arrow-down'} className='expand-100__label__icon w-4 h-4' />
            </div>
            <div className={'expand-100__content ' + (isOpen ? 'is-open' : '')}>{children}</div>
        </div>
    );
}
